import { render } from "./InoutByTab.vue?vue&type=template&id=22c04c65&scoped=true"
import script from "./InoutByTab.vue?vue&type=script&lang=js"
export * from "./InoutByTab.vue?vue&type=script&lang=js"

import "./InoutByTab.vue?vue&type=style&index=0&id=22c04c65&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c04c65"]])

export default __exports__